import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { CompanyDataAnalysisOptions, defaultChartOrTableHeight } from './CompanyDataAnalysisService';
import { Symbols } from '@/symbols';
import { CompanyDataAnalysisViewType } from './CompanyDataAnalysis.type';
import _ from 'lodash';
import { CompanyDataAnalysisEventKey, CompanyDataAnalysisKeyType } from '@/apis/service/company/CompanyDataAnalysisApi.type';
let CompanyChemicalDataAnalysisService = class CompanyChemicalDataAnalysisService {
    constructor(companyDataAnalysisService, companyDataAnalysisApi, i18n) {
        this.companyDataAnalysisService = companyDataAnalysisService;
        this.companyDataAnalysisApi = companyDataAnalysisApi;
        this.i18n = i18n;
        /**
         * 新用户获取权限配置
         */
        this.newUserPermissionOption = new CompanyDataAnalysisOptions();
        /**
         * 新用户获取权限 Detail 配置
         */
        this.newUserPermissionDetailOption = new CompanyDataAnalysisOptions();
        this.newUserPermissionConfigInit();
        this.newUserPermissionDetailConfigInit();
    }
    newUserPermissionConfigInit() {
        this.newUserPermissionOption.reportName = CompanyDataAnalysisKeyType.CHEMICAL_NEW_USER;
        this.newUserPermissionOption.title = this.i18n.t('backoffice.company.dataAnalysis.overview');
        this.newUserPermissionOption.canCollapse = false;
        this.newUserPermissionOption.tips = [];
        const labels = {
            date: this.i18n.t('backoffice.company.dataAnalysis.date'),
            user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
        };
        this.newUserPermissionOption.tableOptions.columns = this.companyDataAnalysisService.getPvUvTableColumns(labels);
        this.newUserPermissionOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionOption.statistics = [];
        this.newUserPermissionOption.chartId = 'newChemicalUserPermissionChart';
        this.newUserPermissionOption.chartHeight = defaultChartOrTableHeight.defaultChartHeight;
    }
    getNewUserPermissionData(params) {
        this.newUserPermissionOption.loading = true;
        const newUserPermissionParams = { ...params, report_name: this.newUserPermissionOption.reportName };
        return this.companyDataAnalysisApi.getCompanyDataAnalysisData(newUserPermissionParams).then(data => {
            this.newUserPermissionOption.Updated = data.data_date;
            this.newUserPermissionDetailOption.Updated = data.data_date;
            this.newUserPermissionOption.noData = data.data_detail.length === 0;
            this.newUserPermissionOption.tableOptions.rows = this.companyDataAnalysisService.getPvUvTableRows(data.data_detail, CompanyDataAnalysisEventKey.CHEMICAL);
            const optionParams = {
                data: data.data_detail,
                user_count: this.i18n.t('backoffice.company.dataAnalysis.NewUserPermission'),
                key: CompanyDataAnalysisEventKey.CHEMICAL,
            };
            this.newUserPermissionOption.chartOption = this.companyDataAnalysisService.getPvUvBarChartOption(optionParams);
        }).catch(() => {
            this.newUserPermissionOption.noData = true;
        }).finally(() => {
            this.newUserPermissionOption.loading = false;
        });
    }
    newUserPermissionDetailConfigInit() {
        this.newUserPermissionDetailOption.reportName = CompanyDataAnalysisKeyType.CHEMICAL_NEW_USER;
        this.newUserPermissionDetailOption.title = this.i18n.t('backoffice.company.dataAnalysis.userDetails');
        this.newUserPermissionDetailOption.tips = [
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.chemicalLoginCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.chemicalLoginCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.chemicalLoginTotalCount'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.chemicalLoginTotalCountTips'),
            },
            {
                label: this.i18n.t('backoffice.company.dataAnalysis.joinDate'),
                desc: this.i18n.t('backoffice.company.dataAnalysis.joinDateTips'),
            }
        ];
        this.newUserPermissionDetailOption.tableOptions.maxHeight = defaultChartOrTableHeight.defaultTableHeightWithTopBox;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.enabled = true;
        this.newUserPermissionDetailOption.tableOptions.paginationOptions.perPageDropdownEnabled = false;
        this.newUserPermissionDetailOption.canChangeViewType = false;
        this.newUserPermissionDetailOption.viewType = CompanyDataAnalysisViewType.Table;
        this.newUserPermissionDetailOption.canCollapse = false;
        this.newUserPermissionDetailOption.tableFields = this.companyDataAnalysisService.getUserTableColumns(CompanyDataAnalysisEventKey.CHEMICAL);
        this.newUserPermissionDetailOption.tableOptions.columns = this.newUserPermissionDetailOption.tableFields;
    }
    async getNewUserPermissionDetailsData(params) {
        let newUserPermissionDetailParams = _.cloneDeep(params);
        this.newUserPermissionDetailOption.loading = true;
        newUserPermissionDetailParams = this.companyDataAnalysisService.getDetailTableDefaultParams(params, this.newUserPermissionDetailOption.reportName);
        // 先获取字段设置
        this.newUserPermissionDetailOption.tableOptions.columns = await this.companyDataAnalysisService.getFiledSettingColumns(this.newUserPermissionOption.reportName, this.newUserPermissionDetailOption.tableFields);
        return this.companyDataAnalysisApi.getCompanyDataAnalysisUserPrivileges(newUserPermissionDetailParams).then(data => {
            this.newUserPermissionDetailOption.noData = data.iTotalRecords === 0;
            this.newUserPermissionDetailOption.tableOptions.paginationOptions.setCurrentPage = Number(data.s_echo);
            this.newUserPermissionDetailOption.tableOptions.totalRecords = data.iTotalRecords;
            this.newUserPermissionDetailOption.tableOptions.totalRows = data.iTotalDisplayRecords;
            this.newUserPermissionDetailOption.tableOptions.rows = this.companyDataAnalysisService.getUserTableRows(data.aaData, CompanyDataAnalysisEventKey.CHEMICAL);
        }).catch(() => {
            this.newUserPermissionDetailOption.noData = true;
        }).finally(() => {
            this.newUserPermissionDetailOption.loading = false;
        });
    }
    async initData(params) {
        Promise.all([
            this.getNewUserPermissionData(params),
            this.getNewUserPermissionDetailsData(params)
        ]);
    }
};
CompanyChemicalDataAnalysisService = __decorate([
    injectable(),
    __param(0, inject(Symbols.CompanyDataAnalysisService)),
    __param(1, inject(Symbols.CompanyDataAnalysisApi)),
    __param(2, inject(Symbols.I18n)),
    __metadata("design:paramtypes", [Object, Object, Object])
], CompanyChemicalDataAnalysisService);
export { CompanyChemicalDataAnalysisService };
